import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppInsightsService {
  appInsights: ApplicationInsights;

  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: environment.appInsightsConnectionString,
      },
    });
    this.appInsights.loadAppInsights();
  }

  logError(error: Error, properties?: Record<string, unknown>): void {
    this.appInsights.trackException({ exception: error, properties });
  }

  logEvent(name: string, properties?: Record<string, unknown>): void {
    this.appInsights.trackEvent({ name, properties });
  }
}
